import errorLogger from '@picsart/growth-rc/services/errorLogger';

const loadingImage = (url: string): Promise<HTMLImageElement> =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = '';
    let loadCount = 0;

    image.onload = () => {
      resolve(image);
    };
    image.onerror = event => {
      if (loadCount >= 1) {
        event && errorLogger.leaveBreadcrumb('Could not load image', { event }, 'error');
        return reject(new Error(`Could not load image at ${url}`));
      }

      loadCount++;
      image.src = url;
    };

    image.src = url;
  });

export default loadingImage;
